module.exports = __webpack_public_path__ + "4d37bfef4c40a2062992dcedb8e91bbf.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_3-320.webp
// module id = 299
// module chunks = 0